import { FC } from "react";
import { useMediaQuery } from "@/hook/use-media-query";
import { ProductCardUI } from "@/components/product-card/product-card-ui";
import { ProductDetailsResponse } from "@/types/product";

const RelatedItemList: FC<{
  lists: ProductDetailsResponse[];
}> = ({ lists }) => {
  const lg = useMediaQuery("(min-width: 1024px)");
  const xl = useMediaQuery("(min-width: 1280px)");

  return (
    <div className="hidden  sm:flex flex-wrap justify-start gap-4">
      {lists.slice(0, (xl && 5) || (lg && 4) || 3).map((list) => (
        <ProductCardUI key={list.id} product={list} pageType="relatedProduct" />
      ))}
    </div>
  );
};

export default RelatedItemList;
